/***
 * The sessionStorage service takes care of storing, retrieving and clearing the sessionStorage
 * of the browser. While session storage takes in only string values, the service takes care of
 * serializing and deserializing values to JSON.
 *
 * There is another service for localStorage which stores value in the
 * localStorage. This service stores values in the `sessionStorage`.
 *
 * LocalStorage vs SessionStorage
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage
 */
app.service('sessionStorageService', [ '$window',
  function ($window) {
    const service = this;

    // Basic check to see if the browser supports sessionStorage
    const isSessionStorageAvailable = function () {
      return typeof($window.sessionStorage) !== 'undefined';
    };

    /***
    * Sets an item to the sessionStorage.
    *
    * @param key {string}
    * The key
    *
    * @param value {object}
    * Object to store in sessionStorage
    *
    * @returns {boolean}
    * true - if operation is successful, false otherwise
    */
    service.set_item = function (key, value) {
      if (isSessionStorageAvailable()) {
        $window.sessionStorage.setItem(key, JSON.stringify(value));
        return true;
      }

      return false;
    };

    /***
    * Fetches an item from sessionStorage given the key.
    *
    * @param key {string}
    * The key.
    *
    * @returns {null|any}
    * The object value if found. Null otherwise.
    */
    service.get_item = function (key) {
      if (isSessionStorageAvailable()) {
        const value = $window.sessionStorage.getItem(key);
        if (value != null) {
          return JSON.parse(value);
        }
      }

      return null;
    };

    /***
    * Removes an item from the session storage given the key.
    *
    * @param key
    * The key.
    *
    * @returns {boolean}
    * true if value was removed, false on error.
    */
    service.remove_item = function (key) {
      if (isSessionStorageAvailable()) {
        $window.sessionStorage.removeItem(key);
        return true;
      }

      return false;
    };

    /***
    * Clears all values in the sessionStorage.
    *
    * @returns {boolean}
    * true if successful, false otherwise.
    */
    service.clear = function () {
      if (isSessionStorageAvailable()) {
        $window.sessionStorage.clear();
        return true;
      }

      return false;
    };
  }]
);
